import type { LucideIcon } from 'lucide-react';
import {
  Ban,
  BellRing,
  Check,
  CheckCheck,
  CircleCheck,
  FilePenLine,
  Play,
  Send,
} from 'lucide-react';

import type { FooterAction } from './task-review-helpers';
import { FOOTER_ACTION } from './task-review-helpers';

/** The icon each footer action carries, on the task page and in a document's review dock alike. */
export const FOOTER_ACTION_ICON = {
  [FOOTER_ACTION.Approve]: Check,
  [FOOTER_ACTION.Complete]: CircleCheck,
  [FOOTER_ACTION.MarkComplete]: CheckCheck,
  [FOOTER_ACTION.Reject]: Ban,
  [FOOTER_ACTION.Remind]: BellRing,
  [FOOTER_ACTION.RemindReviewers]: BellRing,
  [FOOTER_ACTION.RequestChanges]: FilePenLine,
  [FOOTER_ACTION.RequestReview]: Send,
  [FOOTER_ACTION.Start]: Play,
} satisfies Record<FooterAction, LucideIcon>;
